import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from '@/shared/modules/layout';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { warehouseAppSidebarWidth } from '@/warehouse/constants';
import { useLocation } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
const AccessLevelLayout = () => {
    const { pathname } = useLocation();
    const warehouseUrlAccessDeniedMessage = useLayoutStore((state) => state.warehouseUrlAccessDeniedMessage);
    return (_jsx(Layout, { sidebarWidth: warehouseAppSidebarWidth, sidebar: _jsx(AppSidebar, {}), accessDeniedMessage: warehouseUrlAccessDeniedMessage, hideFooter: pathname.includes('/receipt') ||
            pathname.includes('/packing/') ||
            pathname.includes('/picking/') ||
            pathname.includes('/blocked') ||
            pathname.includes('/shipping') }));
};
export { AccessLevelLayout };
